import { render, staticRenderFns } from "./SelectAward.vue?vue&type=template&id=771287fa"
import script from "./SelectAward.vue?vue&type=script&lang=js"
export * from "./SelectAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports